import { useFeatureLoyaltyShortCodeConfirmationModalQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useFeaturesLoyaltyShortCodeConfirmationModal = () => {
  const { featureLoyaltyUIId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureLoyaltyShortCodeConfirmationModalQuery({
    variables: { featureLoyaltyUIId },
    skip: !featureLoyaltyUIId,
  });

  return {
    data: data?.LoyaltyUI,
    loading: featureIdsLoading || loading,
  };
};
